"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogPromiseHandler = exports.dialogContentHandler = void 0;
exports.ContentDialog = ContentDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var hooks_1 = require("../../store/hooks");
var dialogContentHandler = {
    body: (0, jsx_runtime_1.jsx)("div", { children: "Default Content Handler" }),
};
exports.dialogContentHandler = dialogContentHandler;
var dialogPromiseHandler = {
    resolve: null,
};
exports.dialogPromiseHandler = dialogPromiseHandler;
function ContentDialog() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.contentDialog; }), isOpen = _a.isOpen, header = _a.header, contentMaxWidth = _a.contentMaxWidth, hideCloseButton = _a.hideCloseButton, isDismissable = _a.isDismissable;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var handleDismiss = function () {
        var _a;
        dispatch((0, content_dialog_1.closeContentDialogThunk)());
        (_a = dialogPromiseHandler["resolve"]) === null || _a === void 0 ? void 0 : _a.call(dialogPromiseHandler, "cancel");
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleDismiss();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: isDismissable, isKeyboardDismissDisabled: !isDismissable, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: contentMaxWidth !== null && contentMaxWidth !== void 0 ? contentMaxWidth : "sm:max-w-[360px]", children: [!hideCloseButton && (0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { onPress: handleDismiss }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Heading, { children: header }) }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { children: dialogContentHandler["body"] })] }) }) }) }));
}
